import {
  useEffect,
  useState,
} from "react";
import {
  apiRequest,
} from "../../shared/api/client";

export type ReportsModuleProps = {
  notify: (message: string) => void;
  dataRefreshVersion: number;
};

export function useReportsWorkspace({
  notify,
  dataRefreshVersion,
}: ReportsModuleProps) {
  const [report, setReport] = useState<{
    completedRequests: number;
    averageOffers: number;
    averageApprovalDays: number | null;
    volumes: Array<{ currency: string; amount: string; request_count: number; }>;
    statuses: Array<{ status: string; count: number; }>;
    categories: Array<{
      category: string;
      currency: string;
      amount: string;
      request_count: number;
    }>;
  } | null>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    apiRequest<NonNullable<typeof report>>("/api/reports/summary")
      .then(setReport)
      .catch((error) =>
        notify(
          error instanceof Error ? error.message : "Rapor verisi alınamadı.",
        ),
      )
      .finally(() => setLoading(false));
  }, [dataRefreshVersion, notify]);
  const exportReport = () => {
    if (!report) return;
    const rows = [
      ["Bölüm", "Gösterge", "Değer", "Para Birimi"],
      ["Özet", "Tamamlanan talep", String(report.completedRequests), ""],
      ["Özet", "Ortalama teklif", report.averageOffers.toFixed(1), ""],
      [
        "Özet",
        "Ortalama onay süresi (gün)",
        report.averageApprovalDays?.toFixed(1) ?? "Veri yok",
        "",
      ],
      ...report.volumes.map((item) => [
        "Onaylı hacim",
        `${item.request_count} talep`,
        item.amount,
        item.currency,
      ]),
      ...report.categories.map((item) => [
        "Kategori",
        item.category,
        item.amount,
        item.currency,
      ]),
    ];
    const csv = rows
      .map((row) =>
        row
          .map((value) => `"${String(value).replaceAll('"', '""')}"`)
          .join(";"),
      )
      .join("\n");
    const url = URL.createObjectURL(
      new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8" }),
    );
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = `anl-satin-alma-raporu-${new Date().toISOString().slice(0, 10)}.csv`;
    anchor.click();
    URL.revokeObjectURL(url);
    notify("Rapor CSV biçiminde dışa aktarıldı.");
  };
  const approvedVolume =
    report?.volumes.length === 1
      ? report.volumes[0].amount
      : report?.volumes.length
        ? `${report.volumes.length} para birimi`
        : "—";
  return {
    report,
    loading,
    exportReport,
    approvedVolume,
  };
}
